<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue'

import { useStoreModalState } from '@/composables/useStoreModalState'
import { useStoreSnapshot } from '@/webgl/composables/useStoreSnapshot'

import AsyncIcon from '../atoms/AsyncIcon.vue'
import CtaComponent from '../atoms/CtaComponent.vue'

interface ShareData{}

export default defineComponent({
  name: 'ShareSnapshot',
  components: { CtaComponent, AsyncIcon },
  props: {
    inStore: { type: Boolean, required: true }
  },
  setup (props, { emit }) {
    const src = ref(null)
    const { snapshotData, snapped } = useStoreSnapshot()
    const { toggleModal } = useStoreModalState()

    const imgBackground = computed(() => {
      return {
        'background-image': `url(${src?.value})`,
        'background-position': 'center',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        opacity: 1
      }
    })

    const downloadImg = (src: string) => {
      if (src) {
        const link = document.createElement('a')
        link.download = 'filter.png'
        link.href = src
        link.click()
      }
    }

    const shareImg = async (src: string) => {
      const data = {
        title: 'DG Beauty Capri 2024',
        text: 'Discover the Italian charm of Capri'
      }

      const img = await fetch(src)
      const blob = await img.blob()

      const file = new File([blob], 'filter.png', { type: 'image/png' })

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ title: data.title, text: data.text, files: [file] } as ShareData)
      }
    }

    onMounted(() => {
      if (snapped.value && snapshotData.value) {
        src.value = snapshotData.value
      }
    })

    return {
      src,
      imgBackground,
      downloadImg,
      shareImg,
      toggleModal
    }
  }
})
</script>

<template>
  <div class="ctn-share relative flex flex-col justify-between items-center h-full w-full offset-header">
    <div class="flex flex-col gap-4 sm:gap-6 items-center justify-center w-full h-full">
      <span class="ctn-img <xs:max-w-[70%] <sm:max-w-[45%] max-w-[40%] ">
        <img
          :src="src"
          class="snapshot block w-full h-full max-h-100 object-contain"
        />
      </span>

      <div
        v-if="!inStore"
        class="wrapper-options flex flex-row gap-4"
      >
        <CtaComponent :is-primary="true" @click.prevent="shareImg(src)">SHARE</CtaComponent>
        <CtaComponent :is-primary="true" @click.prevent="downloadImg(src)">
          <AsyncIcon name="download" class="text-white text-2xl" />
        </CtaComponent>
      </div>

      <CtaComponent v-else :is-primary="true" @click="toggleModal(true)">GET YOUR PHOTO</CtaComponent>
    </div>

    <p class="body-1 h-min text-center text-white uppercase px-4 mb-2">
      Share your light blue experience in Capri with
      <span class="body-1 inline-block capitalize"> #DGSummerVibes</span>
    </p>
  </div>
</template>

<style scoped lang="scss">
//

.ctn-share {
  backdrop-filter: $backdrop;
}
</style>
